import React, { Component } from 'react';
import './PayButtons.scss';
import GooglePayButton from '@google-pay/button-react/dist/index.es5.min.js';
import ApplePayButton from '../PayButtons/ApplePayButton/ApplePayButton';
import languageService from '../../services/languageService';
import parameterService from '../../services/parameterService';
import paymentService from '../../services/paymentService';
import paymentTypeService from '../../services/paymentTypeService';

class PayButtons extends Component {
    constructor(props) {
        super(props);
        this.state = {
            environment: parameterService.getGooglePayEnvironment(),
            canMakeGooglePayments: true
        };
        this.paymentTypes = paymentTypeService.getPaymentTypes();

        try {
            this.canMakeApplePayPayments = this.paymentTypes.some(paymentType => paymentType.type === 'applepay') && window.ApplePaySession && window.ApplePaySession.canMakePayments();
        } catch(error) {
            this.canMakeApplePayPayments = false;
        }
        this.canMakeGooglePayPayments = this.state.canMakeGooglePayments && this.paymentTypes.some(paymentType => paymentType.type === 'googlepay');
        this.showPaymentsContainer = this.canMakeApplePayPayments || this.canMakeGooglePayPayments;
    }

    onLoadPaymentData = paymentData => {
        paymentService.onLoadGooglePaymentData(paymentData)
    }

    onReadyToPayChange = data => {
        this.setState({
            canMakeGooglePayments: data.isButtonVisible
        });
    };

    render() {
        if (!this.showPaymentsContainer) {
            return null;
        }

        return (
            <div className={'d-flex justify-content-center pay-buttons-container'}>
                {this.canMakeGooglePayPayments && <GooglePayButton
                    environment={this.state.environment}
                    buttonLocale={languageService.selected}
                    paymentRequest={parameterService.getGooglePaymentRequest()}
                    onLoadPaymentData={this.onLoadPaymentData}
                    onReadyToPayChange={this.onReadyToPayChange}
                />}
                {this.canMakeApplePayPayments && <ApplePayButton
                    buttonColor='black'
                    buttonLocale={languageService.selected}
                />}
            </div>
        );
    }
}

export default PayButtons;



// WEBPACK FOOTER //
// ./src/components/PayButtons/PayButtons.js